<i class="k-icon k-font-icon k-i-close close" (click)="onClose()"></i>
<div id="simple-page">
  <main>
    <div class="dialog-title">API Key Created</div>
    <p class="dialog-body">
      Make sure you copy <strong>{{ data.keyName }}</strong> as it won't be
      shown again.
    </p>
    <div class="key">
      <pre>{{ data.apiKey }}</pre>
      <i
        *ngIf="!copied"
        style="cursor: pointer"
        class="k-icon k-font-icon k-i-copy px-4"
        (click)="writeToClipboard(data.apiKey)"
      ></i>
      <i
        *ngIf="copied"
        style="cursor: pointer"
        class="k-icon k-font-icon k-i-check px-4"
      ></i>
    </div>
    <button themeColor="primary" kendoButton (click)="onClose()">Close</button>
  </main>
</div>
